'use client';

import { createContext, useState, useMemo } from 'react';
import type { LivestreamingSessionData } from '@/types';

export interface SessionContextType {
  livestreamingSessionData: LivestreamingSessionData | null;
  setLivestreamingSessionData: (value: LivestreamingSessionData | null) => void;
}

export const SessionContext = createContext<SessionContextType>({
  livestreamingSessionData: null,
  setLivestreamingSessionData: () => {},
});

export const SessionProvider = ({ children }: { children: React.ReactNode }) => {
  const [livestreamingSessionData, setLivestreamingSessionData] =
    useState<LivestreamingSessionData | null>(null);

  const value = useMemo(
    () => ({ livestreamingSessionData, setLivestreamingSessionData }),
    [livestreamingSessionData],
  );

  return <SessionContext.Provider value={value}>{children}</SessionContext.Provider>;
};
